import { CheckoutAbTestMetric } from "@redotech/redo-conversion-core-common/checkouts/checkout-ab-test-utils";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { orderValueFilterSchema } from "./get-all-checkout-split-metrics";

export const checkoutSegmentFilterKeysSchema = z.array(z.string()).max(50);

const checkoutMetricData = z.object({
  valuesByTreatment: z.array(
    z.object({ treatmentId: zExt.objectId(), value: z.number() }),
  ),
  // Making nullable until we have a way to calculate confidence
  // for all metrics.
  variantConfidencesByTreatment: z
    .array(z.object({ treatmentId: zExt.objectId(), confidence: z.number() }))
    .nullable(),
});

export const calculateCheckoutSplitResults = {
  name: "calculateCheckoutSplitResults" as const,
  input: z.object({
    splitId: zExt.objectId(),
    orderValueFilter: orderValueFilterSchema.optional(),
    /** Restricts every metric to visits in at least one of these segments. */
    segmentKeys: checkoutSegmentFilterKeysSchema.optional(),
  }),
  output: z.object({
    [CheckoutAbTestMetric.CHECKOUT_CONVERSION_RATE]: checkoutMetricData,
    [CheckoutAbTestMetric.AVERAGE_SHIPPING_REVENUE]: checkoutMetricData,
    [CheckoutAbTestMetric.REVENUE_PER_CHECKOUT_VISIT]: checkoutMetricData,
    [CheckoutAbTestMetric.AVERAGE_ORDER_VALUE]: checkoutMetricData,
    segmentFilterCoverage: z
      .object({
        selectedCheckoutVisits: z.number(),
        totalCheckoutVisits: z.number(),
        minTreatmentCheckoutVisits: z.number(),
      })
      .optional(),
  }),
};

export type CalculateCheckoutSplitResultsOutput = z.infer<
  typeof calculateCheckoutSplitResults.output
>;
